import React from "react";

export default class CommentForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            name: "",
            email: "",
            comment: ""
        };
        this.handleInput = this.handleInput.bind(this);
    }
    render(){
        return(
            <div className="post-comment-form w-100">
                <h2 className="title"> Leave a Comment</h2>
                <div className="card w-100">
                    <div className="card-body">
                        <form>
                            <div className="form-group">
                                <label>Name</label>
                                <input id="name" className="form-control w-100" placeholder="Your Name" value={this.state.name} onChange={this.handleInput} />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input id="email" type="email" className="form-control w-100" placeholder="Your Email" value={this.state.email} onChange={this.handleInput}  />
                            </div>
                            <div className="form-group">
                                <label>Comment</label>
                                <textarea id="comment" className="form-control w-100" rows="4" placeholder="Your Comment" value={this.state.comment} onChange={this.handleInput}  />
                            </div>
                            <button className="btn btn-lx" onClick={this.handleSubmit.bind(this)}>Post Comment</button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
    handleInput(e){
        e.preventDefault();
        let element = e.target;

        this.setState({
            [element.id]: element.value
        });
    }
    handleSubmit(e){
        e.preventDefault();
    }
}
